const request = {
    invalid_input: "L'input non è valido. {{details}}",
    general: 'Si è verificato un errore nella richiesta.',
    /** UNTRANSLATED */
    range_not_satisfiable: 'Range not satisfiable.',
};
export default Object.freeze(request);
